import { render, staticRenderFns } from "./newRamucirumab.vue?vue&type=template&id=43cc833d&scoped=true"
import script from "./newRamucirumab.vue?vue&type=script&lang=js"
export * from "./newRamucirumab.vue?vue&type=script&lang=js"
import style0 from "./newRamucirumab.vue?vue&type=style&index=0&id=43cc833d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc833d",
  null
  
)

export default component.exports